<h2>{{ title | transloco }}</h2>
<div class="olympic-panel-container">
  <div>
    <ng-container *ngIf="olympic_data[0].Caps > 0">
      <app-olympic-insight-container
        [number]="olympic_data[0].Caps"
        [title]="short_title | transloco"
        [subtitle]="'Appearances' | transloco"
      ></app-olympic-insight-container>
    </ng-container>
    <div *ngIf="olympic_data[0].Podiums > 0">
      <app-olympic-insight-container
        [number]="olympic_data[0].Podiums"
        [title]="short_title | transloco"
        [subtitle]="'Podiums' | transloco"
      ></app-olympic-insight-container>
    </div>
    <div *ngIf="olympic_data[0].Medals.Golds > 0">
      <app-olympic-insight-container
        [number]="olympic_data[0].Medals.Golds"
        [title]="short_title | transloco"
        [subtitle]="olympic_data[0].Medals.Golds > 1 ? 'Golds' : 'Gold' | transloco"
      ></app-olympic-insight-container>
    </div>
  </div>

  <app-wa-table
    [defaultSort]="'EDITION'"
    [data]="
      { olympics: allDataProcess }
        | sortOlympicPanel
          : {
              sort_name: filter_service.sortLocator['_sortingType'],
              order: filter_service.sortLocator['_orderAsc']
            }
    "
    *ngIf="allDataProcess"
    [isSortableFunc]="sortClass"
    [showCondition]="true"
    [headers]="headers"
    [isDataLoading]="loading"
    [areMoreData]="areMoreData()"
    (loadMore)="loadMore()"
    [data]="allDataProcess"
    (headerClick)="changeSort($event)"
  >
    <ng-template
      [extraClass]="['wa-table__cell--fit-right']"
      app-column
      let-olympic
    >
      <span class="uppertext-black-no-viewport">{{ olympic.Year }}</span>
      <span>&#32;-&#32;</span>
      <span>{{ olympic.Place }}</span>
    </ng-template>
    <ng-template
      [extraClass]="['wa-table__cell--fit-right']"
      app-column
      let-olympic
    >
      <div>{{ olympic.Type }}</div>
    </ng-template>
    <ng-template
      [extraClass]="['wa-table__cell--fit-left' ]"
      app-column
      let-olympic
    >
      <div>
        <ng-container [ngSwitch]="olympic?.Event?.Outcome">
          <div *ngSwitchCase="'Gold'">
            <div class="position medal-gold"></div>
          </div>
          <div *ngSwitchCase="'Silver'">
            <div class="position medal-silver"></div>
          </div>
          <div *ngSwitchCase="'Bronze'">
            <div class="position medal-bronze"></div>
          </div>
          <div *ngSwitchDefault>{{ olympic?.Event?.Outcome }}</div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template
      app-column-responsive
      let-olympic
    >
      <span>
        <span class="uppertext-black-no-viewport">{{ olympic.Year }}</span>
        <span>&#32;-&#32;</span>
        <span>{{ olympic.Place }}</span>
      </span>
      <div>
        <div class="mobile-medal">
          <div>{{ olympic.Type }} -</div>
          <ng-container [ngSwitch]="olympic?.Event?.Outcome">
            <div *ngSwitchCase="'Gold'">
              <div class="position medal-gold"></div>
            </div>
            <div *ngSwitchCase="'Silver'">
              <div class="position medal-silver"></div>
            </div>
            <div *ngSwitchCase="'Bronze'">
              <div class="position medal-bronze"></div>
            </div>
            <div *ngSwitchDefault>{{ olympic?.Event?.Outcome }}</div>
          </ng-container>
        </div>
        <div></div>
      </div>
    </ng-template>
  </app-wa-table>
</div>
